import React from 'react';
import { LocationDocument } from '../types';
import { haversineDistance } from '../lib/haversineDistance';
import AffiliationsList from './AffiliationsList';
import TopBar from './TopBar';
import PhoneIcon from '../icons/PhoneIcon';
import LocationIcon from '../icons/LocationIcon';
interface ViewLocationDetailsProps {
	location: LocationDocument;
	currentLatitude: number;
	currentLongitude: number;
	onBackClick: () => void;
}

const LocationDetails = ({
	location,
	currentLatitude,
	currentLongitude,
	onBackClick,
}: ViewLocationDetailsProps) => {
	const [longitude, latitude] = location.coordinates;
	const distance = haversineDistance(currentLatitude, currentLongitude, +latitude, +longitude);

	return (
		<div className={`fi-location-details fi-location-details--${window.findaConnector?.view}`}>
			<TopBar onClick={onBackClick} children="Back to Search" />
			<div className="fi-location-details__info">
				<div className="fi-location-details__details">
					<h3 className="fi-location-details__title">{location.title}</h3>
					<div className="fi-location-details__address">
						{'undefined' !== typeof location.meta.address && location.meta.address}
						<br />
						{'undefined' !== typeof location.meta.city && location.meta.city}
						{', '}
						{'undefined' !== typeof location.meta.state && location.meta.state}
					</div>
					<div className="fi-buttons">
						{location.meta.phone_number && (
							<a href={`tel:${location.meta.phone_number}`} className="fi-button">
								<PhoneIcon />
								{'undefined' !== typeof location.meta.phone_number &&
									location.meta.phone_number}
							</a>
						)}
						<a
							className="fi-button"
							href={window.findaConnector.locationBaseUrl + '/' + location.slug}
						>
							View Surgery Center
						</a>
					</div>
				</div>
				<div className="fi-location-details__distance">
					<LocationIcon />
					{isNaN(distance) ? '-.--' : distance.toFixed(2)}
					mi
				</div>
			</div>
			{'affiliation' === window.findaConnector?.view && (
				<AffiliationsList
					locations={[location]}
					currentLatitude={currentLatitude}
					currentLongitude={currentLongitude}
					hideDistance={true}
				/>
			)}
		</div>
	);
};

export default LocationDetails;
